import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Link as RouterLink } from 'react-router-dom';
import {
    Container, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
    TextField, Button, LinearProgress, FormControl
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { unpair, openUnpairDialog } from '../../actions/configuration';
import equal from 'fast-deep-equal';
import { useTranslation } from 'react-i18next';
import useUser from '../../user/useUser';

const UnpairDialog = () => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const { token, unsetUser } = useUser();
    const loading = useSelector(state => state.global.loading);
    const alarmSystem = useSelector(state => state.configuration.alarmSystem);
    const unpairDialog = useSelector(state => state.configuration.unpairDialog);
    const generalErrorText = useSelector(state => state.configuration.generalErrorText);
    const dispatch = useDispatch();
    const language = i18n.languages[0];

    if (!alarmSystem)
        return null;

    return (
        <Dialog
            disableBackdropClick={loading}
            open={unpairDialog.isOpen}
            onClose={() => dispatch(openUnpairDialog(false))}>
            <DialogTitle>{t("Unpair")}</DialogTitle>
            <DialogContent>

                {loading ? <LinearProgress style={{ height: 3 }} /> : <div style={{ height: 3 }} />}

                {generalErrorText ? <Alert style={{ marginTop: 10 }} severity="error">{generalErrorText}</Alert> : null}

                <div style={{ maxWidth: 300, marginTop: 20, marginBottom: 20 }}>

                    <FormControl fullWidth style={{ marginTop: 10 }}>
                        <TextField
                            disabled
                            fullWidth
                            type="text"
                            value={alarmSystem.mac}
                            label={t("MAC")}
                        />
                    </FormControl>

                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={loading} onClick={() => dispatch(openUnpairDialog(false))} color="primary">
                    {t("Cancel")}
                </Button>
                <Button disabled={loading}
                    onClick={() => dispatch(unpair(alarmSystem.id, history, token, unsetUser, t, language))}
                    color="primary">
                    {t("Unpair")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UnpairDialog;